<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M5.5 7.5c0-1.1.9-2 2-2h5.59L19 11.41c.8.8.8 2.08 0 2.83l-5.17 5.17c-.8.8-2.08.8-2.83 0L5.5 13.91V7.5zM7.5 6.5c-.55 0-1 .45-1 1v6.09l5.29 5.29c.39.39 1.02.39 1.41 0l5.17-5.17c.39-.39.39-1.02 0-1.41L12.79 6.5H7.5zM9 9.5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
      />
    </svg>
  </span>
</template>
